// 大学が登録した練習用質問で一問モードを始める URL（#1861）。
// 共通質問の ?questionId=<数値> とは別のパラメータにして混在させない。
export function universityQuestionPracticeHref(questionId: string): string {
  return `/practice?universityQuestionId=${encodeURIComponent(questionId)}`;
}
